import { render, staticRenderFns } from "./product_phone_balance_wx.vue?vue&type=template&id=acb3a628&scoped=true"
import script from "./product_phone_balance_wx.vue?vue&type=script&lang=js"
export * from "./product_phone_balance_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb3a628",
  null
  
)

export default component.exports